'use strict';

import { pulseTimelineAmountCsv } from './pulseTimelineDisplay.js';

function csvCell(value) {
  const s = String(value == null ? '' : value);
  const prefixed = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  if (/[",\n\r]/.test(prefixed)) return `"${prefixed.replace(/"/g, '""')}"`;
  return prefixed;
}

function pulseCsvFilename({ projectNumber, view } = {}) {
  const scope = String(projectNumber || 'project').replace(/[^\w.-]+/g, '-');
  const tab = String(view || 'timeline').replace(/[^\w.-]+/g, '-');
  return `pulse-${scope}-${tab}.csv`;
}

function eventsToCsv(events, ctx = {}) {
  const header = ['occurred_at', 'display_date', 'type', 'title', 'actor', 'description', 'amount', 'amount_cents', 'record_kind', 'record_id'].map(csvCell).join(',');
  const rows = (events || []).map((e) => [
    e.occurred_at,
    e.display_date,
    e.type,
    e.title,
    e.actor,
    e.description,
    pulseTimelineAmountCsv(e, ctx),
    e.amount_cents == null ? '' : e.amount_cents,
    e.record?.kind,
    e.record?.id,
  ].map(csvCell).join(','));
  return [header, ...rows].join('\n');
}

export { csvCell, pulseCsvFilename, eventsToCsv };
